import React from 'react';
import ProductBin from '../components/database/productbin';


export default function BinPage() {
    return (
        <>

            <section >

                <div >
                   <ProductBin /> 
                    
                </div>

            </section>
        </>
    );
}